module.exports = __webpack_public_path__ + "static/media/cogni-homescreen.38413ffe.png";